import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@drdropin-tech/theseus';
import classNames from 'classnames';
export default function HighlightedIcon({ shouldHighlight, icon, className, }) {
    return (_jsx("span", { className: classNames({
            'bg-black/12 transition-all': shouldHighlight,
        }, 'rounded-full p-1', className), children: _jsx(Icon, { name: icon, iconSize: "md" }) }));
}
